import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Building2, User, Download, Loader2 } from 'lucide-react';
import OfficeExpenses from './OfficeExpenses';
import ReimbursementReview from './ReimbursementReview';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

const Expenses = () => {
  const [exporting, setExporting] = useState(false);

  const handleExportAll = async () => {
    setExporting(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API}/api/expenses/export-all`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error('Export failed');
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const disposition = res.headers.get('Content-Disposition');
      const match = disposition && disposition.match(/filename="(.+)"/);
      a.download = match ? match[1] : 'Expenses_Export.zip';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      toast.success('Expenses data exported successfully');
    } catch (err) {
      toast.error('Failed to export expenses data');
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className="space-y-5" data-testid="admin-expenses-page">
      <div className="flex justify-end">
        <button
          onClick={handleExportAll}
          disabled={exporting}
          data-testid="export-all-expenses-btn"
          className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-[#1D35A0] hover:bg-[#162b80] rounded-lg transition-colors disabled:opacity-60"
        >
          {exporting ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
          {exporting ? 'Exporting...' : 'Export All Expenses (ZIP)'}
        </button>
      </div>
      <Tabs defaultValue="office" className="w-full">
        <TabsList className="bg-slate-100 p-1 rounded-lg w-full" data-testid="expense-tabs">
          <TabsTrigger value="office" className="data-[state=active]:bg-white data-[state=active]:shadow-sm px-3 sm:px-4 py-2 text-xs sm:text-sm flex-1" data-testid="tab-office-expenses">
            <Building2 className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1.5" />
            Office Expenses
          </TabsTrigger>
          <TabsTrigger value="reimbursements" className="data-[state=active]:bg-white data-[state=active]:shadow-sm px-3 sm:px-4 py-2 text-xs sm:text-sm flex-1" data-testid="tab-reimbursements">
            <User className="w-3.5 h-3.5 sm:w-4 sm:h-4 mr-1.5" />
            Reimbursements
          </TabsTrigger>
        </TabsList>
        <TabsContent value="office" className="mt-6">
          <OfficeExpenses />
        </TabsContent>
        <TabsContent value="reimbursements" className="mt-6">
          <ReimbursementReview />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Expenses;
